import Vue from 'vue'
import Vuex from 'vuex'
import homeStore from './home/store'
import loginStore from './login/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    homeStore,
    loginStore
  }
})

export default store
